export const page = (page) => {
    return {
        type: "CREATE_GROUP_PAGE_VIEW",
        data: page
    }
} 
